import { render, staticRenderFns } from "./BuyerButton.vue?vue&type=template&id=610fc3e0&lang=pug&"
import script from "./BuyerButton.vue?vue&type=script&lang=js&"
export * from "./BuyerButton.vue?vue&type=script&lang=js&"
import style0 from "./BuyerButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('610fc3e0')) {
      api.createRecord('610fc3e0', component.options)
    } else {
      api.reload('610fc3e0', component.options)
    }
    module.hot.accept("./BuyerButton.vue?vue&type=template&id=610fc3e0&lang=pug&", function () {
      api.rerender('610fc3e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/sales-flow-ui/components/BuyerButton.vue"
export default component.exports